var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8237 6.70605C8.09216 6.70605 5.75944 8.40506 4.81433 10.8033C5.75944 13.2016 8.09216 14.9006 10.8237 14.9006C13.5552 14.9006 15.8879 13.2016 16.8331 10.8033C15.8879 8.40506 13.5552 6.70605 10.8237 6.70605ZM10.8237 13.5349C9.31589 13.5349 8.09216 12.3111 8.09216 10.8033C8.09216 9.29554 9.31589 8.07182 10.8237 8.07182C12.3315 8.07182 13.5552 9.29554 13.5552 10.8033C13.5552 12.3111 12.3315 13.5349 10.8237 13.5349ZM10.8237 9.16443C9.91682 9.16443 9.18477 9.89648 9.18477 10.8033C9.18477 11.7102 9.91682 12.4423 10.8237 12.4423C11.7306 12.4423 12.4626 11.7102 12.4626 10.8033C12.4626 9.89648 11.7306 9.16443 10.8237 9.16443Z",
    fill: "#5A6078"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.30891,
    y: 1.28865,
    width: 19.0016,
    height: 19.0016,
    rx: 9.50078,
    stroke: "#5A6078",
    strokeWidth: 1.00156
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.490d0d73d9c6b77d460e2c52989930cc.svg";
export { ForwardRef as ReactComponent };